<template>
  <div style="display: flex; justify-content: center; margin: 30px;">
    <div>
      <h4>{{ $t("tenants.file.file_explorer") }}</h4>
      <ul>
        <tree-item
          v-for="item in rootDirectories"
          :key="item.path"
          :item="item"
          @fetchChildren="fetchChildren"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api';
import axios from '@axios';
import TreeItem from './TreeItem.vue';

export default {
  components: {
    TreeItem,
  },
  setup() {
    const rootDirectories = ref([]);

    const loadRoot = async () => {
      try {
        const params = {
          storage_type: 'aws',
          directory: '',
          page: 1,
          per_page: 10,
        };

        const response = await axios.get(
          `${window.__env.VUE_APP_FILESYSTEM_URL}/v1/files/directory`,
          { params }
        );

        const subdirectories = response.data.subdirectories || [];
        const files = response.data.files || [];

        rootDirectories.value = [
          ...subdirectories.map((dir) => ({
            name: dir.name,
            path: dir.name,
            children: [],
            isExpanded: false,
            isDirectory: true,
            loading: false,
            totalRecords: dir.total_records || 0,
            totalFiles: dir.total_files || 0,
            totalSubdirectoriesFiles: dir.total_subdirectories_files || 0,
            totalPages: response.data.total_pages || 1,
            page: 1,
            per_page: 10,
            filter: {},
          })),
          ...files.map((file) => ({
            name: file.name,
            path: file.name,
            isDirectory: false,
            url: file.url,
          })),
        ];
      } catch (error) {
        console.error('Error loading root directories', error);
      }
    };

    onMounted(() => {
      loadRoot();
    });

    const fetchChildren = async (item, page = 1, per_page = 10, filter = {}) => {
      try {
        item.loading = true;
        const params = {
          storage_type: 'aws',
          directory: item.path || '',
          page,
          per_page,
          ...filter,
        };

        const response = await axios.get(
          `${window.__env.VUE_APP_FILESYSTEM_URL}/v1/files/directory`,
          { params }
        );

        const files = response.data.files || [];
        const subdirectories = response.data.subdirectories || [];

        item.totalRecords = response.data.total_records || 0;
        item.totalPages = response.data.total_pages || 1;
        item.page = response.data.page || page;
        item.per_page = per_page;
        item.filter = filter;

        item.children = [
          ...subdirectories.map((dir) => ({
            name: dir.name,
            path: `${item.path}/${dir.name}`,
            children: [],
            isExpanded: false,
            isDirectory: true,
            loading: false,
            totalRecords: dir.total_records || 0,
            totalFiles: dir.total_files || 0,
            totalSubdirectoriesFiles: dir.total_subdirectories_files || 0,
            totalPages: dir.total_pages || 1,
            page: 1,
            per_page: 10,
            filter: {},
          })),
          ...files.map((file) => ({
            name: file.name,
            path: `${item.path}/${file.name}`,
            isDirectory: false,
            url: file.url,
          })),
        ];
        item.isExpanded = true;
      } catch (error) {
        console.error('Error fetching directory', error);
      } finally {
        item.loading = false;
      }
    };

    return {
      rootDirectories,
      fetchChildren,
    };
  },
};
</script>

<style scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
